<template>
  <div>
    <v-container fluid grid-list-md class="padding_10">
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12 lg12 md12 style="display: flex; flex-wrap: wrap; align-items: center;">
          <v-flex xs12 md6 lg4>
            <v-hover>
              <v-card @click="importMetroTrainScheduleDialog=true; metrotrain=true; metroschedule=false;"
                      class="mx-auto"
                      max-width="340" style="cursor: pointer;"
              >
                <div style="display: flex;justify-content: center;align-items: center;">
                  <v-icon color="#bbbbc6" style="font-size: 100px;"
                          class="black--text mr-2">tram
                  </v-icon>
                </div>
                <!--              <v-span name="local" style="font-size: 200%;margin:20px;color:#A52A2A;"></v-span>-->
                <v-card-title style="display: flex;justify-content: center;align-items: center;">

                  Import Metro Trains
                </v-card-title>
              </v-card>
            </v-hover>
          </v-flex>


          <v-flex xs12 md6 lg4>
            <v-card @click="importMetroTrainScheduleDialog=true; metrotrain=false; metroschedule=true;"
                    class="mx-auto"
                    max-width="340" style="cursor: pointer;">
              <div style="display: flex;justify-content: center;align-items: center;">
                <v-icon color="#bbbbc6" style="font-size: 100px;" class="black--text mr-2">tram</v-icon>
              </div>
              <v-card-title style="display: flex;justify-content: center;align-items: center;">
                Import Metro Train Schedule
              </v-card-title>
            </v-card>
          </v-flex>


          <v-flex xs12 md6 lg4>
            <v-hover>
              <v-card @click="downloadCompleteTrainSchedule=true"
                      class="mx-auto"
                      max-width="340" style="cursor: pointer;"
              >
                <div style="display: flex;justify-content: center;align-items: center;">
                  <v-icon color="#bbbbc6" style="font-size: 100px;"
                          class="black--text mr-2">cloud_download
                  </v-icon>
                </div>
                <!--              <v-span name="local" style="font-size: 200%;margin:20px;color:#A52A2A;"></v-span>-->
                <v-card-title style="display: flex;justify-content: center;align-items: center;">

                  Export Metro Trains/Schedule
                </v-card-title>
              </v-card>
            </v-hover>
          </v-flex>
        </v-flex>


        <v-dialog v-model="importMetroTrainScheduleDialog" max-width="600">
          <v-card>
            <v-card-title class="headline justify-space-between pb-0">
              <span v-if="metrotrain == true">Import Metro Trains</span>
              <span v-if="metroschedule == true">Import Metro Train Schedule</span>
              <v-btn icon @click="importMetroTrainScheduleDialog = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-card-title>

            <v-form ref="metroTrainScheduleImport"
                    id="metroTrainScheduleImport"
                    lazy-validation
                    v-model="valid"
                    data-vv-scope="metroTrainScheduleImport"
                    @submit.prevent="validateBeforeSubmit('metroTrainScheduleImport')">
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 md12>
                    <input type="file" name="master_data_file" ref="fileupload" accept="*/*" id="master_data_file"/>
                  </v-flex>
                </v-layout>
              </v-card-text>

              <br/><br/>

              <v-card-actions>
                <v-layout>
                  <a v-if="metrotrain == true"
                     :href="getBackendPublicURL('MetroTrain-Schedule/Sample_Metro_Train.xlsx')">Click
                    here to Download Train Sample File</a>

                  <a v-if="metroschedule == true"
                     :href="getBackendPublicURL('MetroTrain-Schedule/Sample_Metro_Schedule.xlsx')">Click
                    here to Download Schedule Sample File</a>
                  <v-spacer></v-spacer>

                  <v-btn type="submit"
                         class="mr-3 mb-3"
                         :disabled="!valid || submit_loader"
                         color="primary"
                         :loading="submit_loader">Submit
                  </v-btn>
                </v-layout>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>


        <!--        export metro train and schedule-->
        <v-dialog v-model="downloadCompleteTrainSchedule" max-width="600">
          <v-card>
            <v-card-title class="headline justify-space-between pb-0">
              <v-flex xs12 md12 lg12 style="display: flex;justify-content: space-between;">
                <span>Export Metro Trains/Schedules</span>
                <v-btn icon @click="downloadCompleteTrainSchedule = false">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-flex>
            </v-card-title>
            <v-form ref="exportMetroData"
                    id="exportMetroData"
                    v-model="valid"
                    lazy-validation
                    data-vv-scope="exportMetroData"
                    @submit.prevent="validateBeforeSubmit('exportMetroData')">
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 md6>
                    <v-select
                        solo flat
                        v-model="exportType"
                        :loading="loading_lines"
                        :items="types"
                        item-text="type"
                        item-value="value"
                        label="Select Option To Export"
                        :error-messages="errors.collect('exportMetroData.line_id')"
                        v-validate="'required'"
                    ></v-select>
                  </v-flex>

                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-layout justify-end>
                  <v-btn type="submit"
                         class="mr-3 mb-3"
                         :disabled="(exportType == '')"
                         color="primary"
                         :loading="loading_submit">Export
                  </v-btn>
                </v-layout>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>

        <v-snackbar
            :color="snackBar.color"
            :top="snackBar.top"
            :bottom="snackBar.bottom"
            :left="snackBar.left"
            :right="snackBar.right"
            v-model="snackBar.show"
        >
          {{ snackBar.message }}
          <v-btn dark flat @click.native="snackBar.show = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-snackbar>

      </v-layout>
    </v-container>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "MetroImport",
  data() {
    return {
      importMetroTrainScheduleDialog: false,
      downloadCompleteTrainSchedule: false,
      metrotrain: false,
      metroschedule: false,
      submit_loader: false,
      valid: false,
      snackBar: {
        show: false,
        color: "",
        message: "",
        top: true,
        right: true,
        bottom: false,
        left: false
      },
      loading_lines: false,
      loading_submit: false,
      exportType: '',
      types: [
        {type: 'Metro Trains', value: 'train'},
        {type: 'Metro Schedules', value: 'schedule'}
      ]
    }
  },
  methods: {
    validateBeforeSubmit(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this[scope]();
        }
      });
    },
    getBackendPublicURL(filePath) {
      return `${process.env.VUE_APP_API_URL}/${filePath}`
    },
    metroTrainScheduleImport() {
      this.startLoading();
      this.submit_loader = true;

      let URL = '';
      if (this.metrotrain == true) {
        URL = 'import-metro-trains'

      } else if (this.metroschedule == true) {
        URL = 'import-metro-schedule'
      }
      var myForm = $('#metroTrainScheduleImport')[0];
      let formData = new FormData(myForm);
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/` + URL, formData, {headers: this.$headers})
          .then((response) => {
            this.storeDialog = false
            if (response.data.status == 1) {

              const url = `${process.env.VUE_APP_API_URL}/` + response.data.data;
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', response.data.data);
              document.body.appendChild(link);
              link.click();
              this.importMetroTrainScheduleDialog = false;
              this.$refs.metroTrainScheduleImport.reset();
              this.file = '';
              document.getElementById("master_data_file").value = "";
              this.$refs.fileupload.value = null;
              this.snackBar.message = response.data.message;
              this.snackBar.show = true;
            } else {
              this.snackBar.message = response.data.message;
              this.snackBar.show = true;
              this.importMetroTrainScheduleDialog = false;
              this.file = '';
              this.$refs.form.reset();
              document.getElementById("master_data_file").value = "";
            }
          }).finally(() => {
        this.submit_loader = false;
        this.file = '';
        document.getElementById("master_data_file").value = "";
        this.$refs.fileupload.value = null;
        this.importMetroTrainScheduleDialog = false;
        this.stopLoading();
      });
    },
    download(type, data) {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;

      var exportType;
      if (type == 'train') {
        exportType = "Train"
      } else if (type == 'schedule') {
        exportType = "Schedule"
      }
      link.setAttribute('download',
          'Metro_' + exportType + "_" + moment().format('YYYY-MM-DD')
          + '.csv');
      document.body.appendChild(link);
      link.click();
    },
    exportMetroData() {
      let formData = new FormData;
      formData.append('type', this.exportType);
      this.startLoading();
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/export-metro-data`, formData, {
        headers: this.$headers,
        responseType: 'blob'
      }).then(
          (response) => {
            if (response.data) {
              this.stopLoading();
              this.download(this.exportType, response.data);
              this.downloadCompleteTrainSchedule = false;
              this.exportType = '';

            } else if (response.data.status == 0) {
              this.stopLoading();
              this.snackBar.message = response.data.message;
              this.snackBar.show = true;
              this.downloadCompleteTrainSchedule = false;
              this.exportType = '';
            }
          }
      ).catch((error) => {
        this.snackBar.message = "Error Occurred";
        this.stopLoading();
        this.snackBar.show = true;
        this.downloadCompleteTrainSchedule = false;
        this.exportType = '';
      })
    }
  }
}
</script>

<style scoped>

</style>
